import VCDashboard from './VCDashboard';

export default VCDashboard;
